<nz-card [nzTitle]="''" class="picture-card-box" *ngIf="files.length">
    <div nz-card-grid *ngFor="let file of files; index as i" [ngStyle]="gridStyle" class="item-box">
        <app-file-preview [src]="file.path" [fileName]="file.originalname" (fileDelete)="deleteFile(i)" [deleteEnabled]="deleteEnabled" [downloadEnabled]="downloadEnabled" [selectEnabled]="selectEnabled"></app-file-preview>
        <div class="checkbox" *ngIf="selectEnabled">
          <label nz-checkbox [(ngModel)]="file.selected" (ngModelChange)="onSelectChange()"></label>
        </div>
      </div>
  </nz-card>
